import React from "react";
import { Row, Col } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import CustomMenu from "../../../../../../../../shared/components/CustomMenu/CustomMenu";
import { DashboardAlumniPages } from "../../../../../../containers/alumni-admin/AlumniRoutesAdmin";
import AlumniSideBarHeader from "../components/AlumniSideBarHeader";

const AlumniMenuItems = () => {
  const history = useHistory();
  const { pathname } = useLocation();

  return (
    <>
      <Row>
        <Col xs={12}>
          <AlumniSideBarHeader />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <CustomMenu
            data={[
              {
                onClick: () => {
                  history.push(DashboardAlumniPages.ALUMNI_DESCRIPTION);
                },
                text: "Description",
                isActive: pathname === DashboardAlumniPages.ALUMNI_DESCRIPTION,
              },
              {
                onClick: () => {
                  history.push(DashboardAlumniPages.ALUMNI_LIST);
                },
                text: "Alumni List",
                isActive: pathname === DashboardAlumniPages.ALUMNI_LIST,
              },
            ]}
          />
        </Col>
      </Row>
    </>
  );
};

export default AlumniMenuItems;
